import { ADMIN_STATUS_LABEL, STATUS_LABEL } from "../lib/format";

export const LikeBar = ({ pct, height = 6, width, grey = false, testId }) => (
  <div aria-hidden="true" className={`likebar${grey ? " grey" : ""}`} style={{ height, width, flex: width ? "none" : undefined }}
    data-testid={testId}>
    <span style={{ width: `${pct}%` }} />
  </div>
);

export const StatusBadge = ({ status, admin = false, small = false, label }) => (
  <span className={`badge s-${status}${small ? " sm" : ""}`} data-testid={`status-${status}`}>
    <i aria-hidden="true" />
    {label || (admin ? ADMIN_STATUS_LABEL : STATUS_LABEL)[status] || status}
  </span>
);

export const Avatar = ({ text, size = 40, style }) => (
  <span aria-hidden="true" className="avatar" style={{ width: size, height: size, fontSize: Math.round(size * 0.36), ...style }}>
    {text}
  </span>
);

export const Loader = ({ label = "Loading" }) => (
  <div role="status" style={{ padding: "80px 0", textAlign: "center", color: "var(--muted)" }} data-testid="page-loader">
    {label}…
  </div>
);

export const Empty = ({ title, children }) => (
  <div style={{ border: "1.5px dashed var(--dashed)", background: "var(--tint-3)", borderRadius: 16, padding: "32px 24px", textAlign: "center" }}>
    <p className="head" style={{ fontSize: 20, fontWeight: 700, margin: "0 0 6px" }}>{title}</p>
    <div className="hint">{children}</div>
  </div>
);
